import type { ClaimSupportCTA } from "~/lib/api";

const SUPPORT_EMAIL = "info@dataengbytes.com";

export function supportMailtoLink(cityLabel: string, loginEmail?: string): string {
  const subject = encodeURIComponent("DataEngBytes Connect — link my ticket");
  const body = encodeURIComponent(
    [
      "Hi DataEngBytes team,",
      "",
      "I could not automatically link my Connect login to my ticket.",
      "",
      `Connect login email: ${loginEmail ?? "(your sign-in email)"}`,
      "Ticket email (or name + company on ticket): ",
      `Conference: ${cityLabel}`,
      "",
      "Thanks!",
    ].join("\n"),
  );
  return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
}

export function supportMailtoFromCTA(cta: ClaimSupportCTA, loginEmail?: string, cityLabel?: string): string {
  const subject = encodeURIComponent(cta.title);
  const body = encodeURIComponent(
    [
      cta.body,
      "",
      "---",
      `Connect login email: ${loginEmail ?? ""}`,
      cityLabel ? `Conference: ${cityLabel}` : "",
    ]
      .filter(Boolean)
      .join("\n"),
  );
  return `mailto:${cta.email || SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
}